/**
 * 客户管理模块 key
 */
export default {
    /* 客户列表 start */
    // 添加客户-添加单个客户
    C_C_S_S: '添加单个客户',
    C_C_S_S_0: '添加单个客户_保存', // 特殊属性：addition: { channel: '3/7/12' }
    C_C_S_S_1: '添加单个客户_保存并继续添加', // 特殊属性：addition: { channel: '3/7/12' }
    // 添加客户-批量导入
    C_C_B_I: '批量导入',
    // 批量操作
    C_C_B: '批量操作', // 采集时机：hover 鼠标悬浮，触发菜单
    C_C_B_0: '批量操作_打标签', // 特殊属性：addition: { total: number, is_all: boolean }
    C_C_B_1: '批量操作_分配成员', // 特殊属性：addition: { total: number, is_all: boolean }
    C_C_B_1_0: '批量操作_分配成员_确定', // 特殊属性：addition: { total: number, is_all: boolean }
    C_C_B_2: '批量操作_加入黑名单', // 特殊属性：addition: { total: number, is_all: boolean }
    C_C_B_3: '批量操作_移出黑名单', // 特殊属性：addition: { total: number, is_all: boolean }
    C_C_B_4: '批量操作_删除', // 特殊属性：addition: { total: number, is_all: boolean }
    C_C_B_4_0: '批量操作_删除_确定', // 特殊属性：addition: { total: number, is_all: boolean }
    C_C_B_5: '批量操作_创建自定义受众', // 特殊属性：addition: { total: number, is_all: boolean }
    C_C_B_5_0: '批量操作_创建自定义受众_确定', // 特殊属性：addition: { total: number, is_all: boolean }
    C_C_B_6: '批量操作_批量回聊', // 特殊属性：addition: { total: number, is_all: boolean }
    C_C_B_6_0: '批量操作_批量回聊_确定', // 特殊属性：addition: { total: number, is_all: boolean }
    // 导出
    C_C_E_0: '导出最近最大数量',
    C_C_E_1: '导出已选', // 特殊属性：addition: { total: number, is_all: boolean }
    C_C_E_2: '导出最近最大数量',
    C_C_E_3: '导出已选', // 特殊属性：addition: { total: number, is_all: boolean }
    // 字段设置
    C_C_F_0: '字段显示',
    C_C_F_0_0: '字段显示_确定',
    C_C_F_1: '添加自定义字段',
    // 回聊
    C_C_C_B: '回聊',
    // 详情
    C_C_D: '详情',
    C_C_D_0: '详情_回聊',
    /* 客户列表 end */

    /* 会话管理-会话列表 start */
    // 会话标签管理
    C_C_S_T_M: '会话标签管理',
    // 导出会话记录
    C_C_S_S_R_0: '导出会话记录_最近最大数量', // 特殊属性：addition: { tab_type: '0/1/2/3/4' }
    C_C_S_S_R_1: '导出会话记录_已选', // 特殊属性：addition: { total: number, is_all: boolean, tab_type: '0/1/2/3/4' }
    // 导出会话聊天记录
    C_C_S_C_R_0: '导出会话聊天记录_最近最大数量', // 特殊属性：addition: { tab_type: '0/1/2/3/4' }
    C_C_S_C_R_1: '导出会话聊天记录_已选', // 特殊属性：addition: { total: number, is_all: boolean, tab_type: '0/1/2/3/4' }
    // 分配成员
    C_C_S_A_M: '分配成员', // 特殊属性：addition: { tab_type: '0/1/2/3/4' }
    // 添加会话标签
    C_C_S_S_T: '添加会话标签', // 特殊属性：addition: { tab_type: '0/1/2/3/4' }
    // 质检评分
    C_C_S_Q_S: '质检评分',
    C_C_S_Q_S_0: '质检评分_确定',
    // 质检备注
    C_C_S_Q_R: '质检备注',
    C_C_S_Q_R_0: '质检备注_确定',
    // 详情
    C_C_S_C_B: '详情',
    // 回聊
    C_C_S_C_B_0: '详情_回聊',
    /* 会话管理-会话列表 end */

    /* 会话管理-搜索聊天内容 start */
    // 切换展示类型
    C_C_C_S_T: '切换展示类型', // 特殊属性：addition: { type: 'message/session' }
    // 搜索关键词
    C_C_C_K_W: '搜索关键词',
    // 筛选时间
    C_C_C_F_T: '筛选时间',
    // 筛选成员
    C_C_C_F_M: '筛选成员',
    /* 会话管理-搜索聊天内容 end */

    /* 表单管理-订单列表 start */
    // 订单设置
    C_F_O_S: '订单设置',
    // 订单搜索
    C_F_O_W: '订单搜索',
    // 导出
    C_F_O_E_0: '导出最近最大数量',
    C_F_O_E_1: '导出已选', // 特殊属性：addition: { total: number, is_all: boolean }
    // 批量删除
    C_F_O_B_0: '批量删除', // 特殊属性：addition: { total: number, is_all: boolean }
    C_F_O_B_1: '批量删除_确定', // 特殊属性：addition: { total: number, is_all: boolean }
    // 编辑
    C_F_O_C: '编辑',
    C_F_O_C_0: '编辑_保存',
    // 删除
    C_F_O_D: '删除',
    C_F_O_D_0: '删除_确定',
    /* 表单管理-订单列表 end */

    /* 标签管理-访客标签 start */
    // 添加分类
    C_T_V_A_C: '添加分类',
    C_T_V_A_C_0: '添加分类_确定',
    // 删除分类
    C_T_V_D_C: '删除分类',
    C_T_V_D_C_0: '删除分类_确定', // 特殊属性：addition: { is_del_group: '0/1' }
    // 切换排序类型
    C_T_V_S_T: '切换排序类型', // 特殊属性：addition: { sort_type: '0/1' }
    // 添加标签
    C_T_V_A_T: '添加标签',
    C_T_V_A_T_0: '添加标签_确定',
    // 修改排序
    C_T_V_E_O: '修改排序',
    C_T_V_E_O_0: '修改排序_确定',
    /* 标签管理-访客标签 end */

    /* 会话标签 start */
    // 添加标签
    C_T_S_A_T: '添加标签',
    C_T_S_A_T_0: '添加标签_确定',
    // 删除标签
    C_T_S_D_T: '删除标签',
    C_T_S_D_T_0: '删除标签_确定',
    /* 会话标签 end */

    /* 话术库 start */
    // 切换话术库类型
    C_V_C_L_T: '切换话术库类型', // 特殊属性：addition: { type: '0/1/2' }
    // 添加话术库
    C_V_A_L: '添加话术库',
    C_V_A_L_0: '添加话术库_确定',
    // 话术库排序
    C_V_S_L: '话术库排序',
    // 添加分类
    C_V_A_C: '添加分类',
    C_V_A_C_0: '添加分类_确定',
    // 分类排序
    C_V_S_C: '分类排序',
    // 添加话术
    C_V_A_S: '添加话术',
    C_V_A_S_0: '添加话术_确定',
    // 话术排序
    C_V_S_S: '话术排序',
    C_V_S_S_0: '话术排序_确定',
    // 导入/导出
    C_V_I_E: '导入/导出',
    C_V_I_E_0: '导出Excel',
    C_V_I_E_1: '上传Excel',
    C_V_I_E_2: '确定导入',
    // 话术排序
    C_V_D_S: '删除话术',
    C_V_D_S_0: '删除话术_确定',
    /* 话术库 end */

    /* 素材库 start */
    // 上传图片
    C_M_U_I: '上传图片',
    C_M_U_I_0: '上传图片_点击上传',
    // 上传视频
    C_M_U_V: '上传视频',
    C_M_U_V_0: '上传视频_点击上传',
    // 上传音频
    C_M_U_A: '上传音频',
    C_M_U_A_0: '上传音频_点击上传',
    // 上传附件
    C_M_U_F: '上传附件',
    C_M_U_F_0: '上传附件_点击上传',
    // 复制ID
    C_M_C_I: '复制ID',
    // 添加描述
    C_M_A_D: '添加描述',
    C_M_A_D_0: '添加描述_保存',
    // 删除
    C_M_D_M: '删除',
    C_M_D_M_0: '删除_确定',
    /* 素材库 end */
};
